import React, { useState } from 'react';
import { Container, Card, CardBody, CardHeader, Button, Col, Row } from 'reactstrap';
import { useCookies } from 'react-cookie';
import { useHistory } from 'react-router-dom';
import './styles.css'

import Header from '../../components/Headers/Header';


export default function SubconsciousHealingForm() {

    const [, setCookies] = useCookies(['sh_package', 's_count']);
    const [data, setData] = useState('60_MINS_SH');
    let history = useHistory();

    console.log('60 Min SH Price:', process.env.REACT_APP_60_MIN_SH_PRICE);
    console.log('90 Min SH Price:', process.env.REACT_APP_90_MIN_SH_PRICE);

    const sh_packages = {
    "60_MINS_SH": {
        name: "60 Minutes Subconscious Healing",
        goal: `
    A gentle yet powerful introduction to subconscious and shadow healing.

    This intuitively channelled tarot-guided subconscious healing session is designed to help you access the deeper layers of your inner world — the emotions, beliefs, and patterns that often operate beneath conscious awareness.

    Using tarot as a symbolic mirror rather than a predictive tool, we explore what your subconscious is ready to reveal and gently bring awareness, compassion, and healing to the parts of you seeking integration.

    This session may support you if you:
    • Feel emotionally stuck or confused
    • Are repeating certain patterns in relationships or life
    • Sense unresolved emotions beneath the surface
    • Are beginning or deepening your healing journey
    • Feel drawn to tarot as a tool for self-awareness and healing

    What to expect:
    • Intention setting and grounding
    • Tarot cards drawn to reveal subconscious themes
    • Intuitive interpretation and gentle shadow exploration
    • Emotional awareness and energetic support
    • Closing reflection and grounding

    All sessions are held in a safe, confidential, and non-judgmental space.
        `,
        duration: "1 time - 60 Minutes",
        check_ins: "",
        fee: `£${process.env.REACT_APP_60_MIN_SH_PRICE}`,
        roll_over: ""
    },

    "90_MINS_SH": {
        name: "90 Minutes Subconscious Healing",
        goal: `
        A deeper, immersive healing container for profound inner work and transformation.

        This extended session is for those ready to explore the root layers of the subconscious — where core wounds, suppressed emotions, and long-held patterns reside.

        Unlike a standard tarot session, this is a fully held healing journey. Intuitively channelling and tarot cards becomes the language of the subconscious, guiding us into deeper shadow aspects with compassion, presence, and nervous-system safety. The focus is not only on awareness, but on emotional processing, energetic release, and integration.

        This session is spacious, intentional, and designed to allow what needs to surface to do so without rush or overwhelm.

        This deep journey is especially supportive if you:
        · Have done inner work but feel stuck at a deeper level
        · Experience recurring emotional or relational patterns
        · Feel heavy emotions without a clear source
        · Are ready to meet your shadow with honesty and compassion
        · Desire transformation rather than insight alone

        Session flow:
        · Grounding and nervous system regulation
        · Tarot mapping of subconscious and shadow themes
        · Compassionate exploration of core wounds or inner child aspects
        · Energetic and subconscious healing support
        · Integration guidance and closing grounding

        These sessions are held in a safe, non-judgmental, and supportive space and are highly confidential.`,
        duration: "1 time - 90 Minutes",
        check_ins: "",
        fee: `£${process.env.REACT_APP_90_MIN_SH_PRICE}`,
        roll_over: ""
    }
    };


    async function redirectToPaymentPage(ev) {
        setCookies('sh_package', data);
        setCookies('sh_count', 1);
        history.push('/buy-classes');
    }

    return (
        <React.Fragment>
            <Header />
            <Container className="mt--7" fluid>
                <Card className="bg-secondary shadow">
                    <CardHeader className="bg-transparent w-100">
                        <h2 className="mb-0 w-100 text-center">Fill Up Your Subconscious Healing registration Form</h2>
                    </CardHeader>
                    <CardBody>

                        <Row className='mb-4'>
                            <Col xs={12} md={6} className='my-3'>
                                <Card
                                    onClick={() => setData('60_MINS_SH')}
                                    className={`p-4 text-center h-100 text-xl font-weight-600 pointer shadow card-lift--hover ${data === '60_MINS_SH' ? 'bg-primary text-white' : ''}`}
                                >
                                    60 Minute Subconscious Healing
                                </Card>
                            </Col>
                            <Col xs={12} md={6} className='my-3'>
                                <Card
                                    onClick={() => setData('90_MINS_SH')}
                                    className={`p-4 text-center text-xl h-100 font-weight-600 pointer shadow card-lift--hover ${data === '90_MINS_SH' ? 'bg-primary text-white' : ''}`}
                                >
                                    90 Minute Subconscious Healing
                                </Card>
                            </Col>

                        </Row>

                        <Card className='mb-4'>
                            <CardBody>
                                <div className='d-flex align-items-start pb-4 mb-4 border-bottom'>
                                    <i className='lni lni-flag mx-auto mt-1' style={{ fontSize: '2rem' }} />
                                    <div className='flex-fill ml-3'>
                                        <h4 className='text-lg'>Goal</h4>
                                        <p className='mb-0 goal-text'>
                                            {sh_packages[data].goal}
                                        </p>
                                    </div>
                                </div>
                                <Row>
                                    <Col xs={12} md={6} lg={data === '60_MINS' ? 4 : 3}>
                                        <div className='d-flex align-items-start'>
                                            <i className='lni lni-timer mx-auto mt-1' style={{ fontSize: '2rem' }} />
                                            <div className='flex-fill ml-3'>
                                                <h4 className='text-lg'>Duration</h4>
                                                <p className='mb-0'>
                                                    {sh_packages[data].duration}
                                                </p>
                                            </div>
                                        </div>

                                    </Col>
                                    {
                                        sh_packages[data].check_ins &&
                                        <Col xs={12} md={6} lg={3}>
                                            <div className='d-flex align-items-start'>
                                                <i className='lni lni-phone-set mx-auto mt-1' style={{ fontSize: '2rem' }} />
                                                <div className='flex-fill ml-3'>
                                                    <h4 className='text-lg'>Progress check ins </h4>
                                                    <p className='mb-0'>
                                                        {sh_packages[data].check_ins}
                                                    </p>
                                                </div>
                                            </div>
                                        </Col>
                                    }
                                    <Col xs={12} md={6} lg={data === '60_MINS' ? 4 : 3}>
                                        <div className='d-flex align-items-start'>
                                            <i className='lni lni-pound mx-auto mt-1' style={{ fontSize: '2rem' }} />
                                            <div className='flex-fill ml-3'>
                                                <h4 className='text-lg'>Fee</h4>
                                                <p className='mb-0'>
                                                    {sh_packages[data].fee}
                                                </p>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col xs={12} md={6} lg={data === '60_MINS' ? 4 : 3}>
                                        <div className='d-flex align-items-start'>
                                            <i className='lni lni-calendar mx-auto mt-1' style={{ fontSize: '2rem' }} />
                                            <div className='flex-fill ml-3'>
                                                <h4 className='text-lg'>Roll over plan</h4>
                                                <p className='mb-0'>
                                                    {sh_packages[data].roll_over}
                                                </p>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                                <div className='d-flex align-items-start mb-4 pt-4 mt-4 border-top'>
                                    <i className='lni lni-book mx-auto mt-1' style={{ fontSize: '2rem' }} />
                                    <div className='flex-fill ml-3'>
                                        <h4 className='text-lg'>Terms And Conditions</h4>
                                        <div className='d-flex align-items-start mb-2'>
                                            <i className='lni lni-checkmark mt-1 mx-auto' />
                                            <div className='flex-fill ml-3'>
                                                The client is required to fill in a client questionnaire prior to starting the process requiring all important information to conduct an in depth analysis of the current lifestyle and diet. This will enable me to provide you a customized plan rightly suiting your existing food habits and lifestyle.
                                            </div>
                                        </div>
                                        <div className='d-flex align-items-start mb-2'>
                                            <i className='lni lni-checkmark mt-1 mx-auto' />
                                            <div className='flex-fill ml-3'>
                                                Our success lies in team work which is highly dependent on being jointly accountable towards your transformation journey. Goal is to attain a healthy weight loss whilst improving overall health through simple lifestyle changes. As a coach I will be trying my best to make the plan sustainable and achievable through easy to adopt lifestyle changes wherever needed.
                                            </div>
                                        </div>
                                        <div className='d-flex align-items-start mb-2'>
                                            <i className='lni lni-checkmark mt-1 mx-auto' />
                                            <div className='flex-fill ml-3'>
                                                Regular updates through scale movements, body stats measurements and overall general well being are the only way we will know the success or opportunity to modify anything. Clients are required to keep the coach updated of these from time to time in this process.
                                            </div>
                                        </div>
                                        <div className='d-flex align-items-start mb-2'>
                                            <i className='lni lni-checkmark mt-1 mx-auto' />
                                            <div className='flex-fill ml-3'>
                                                Once a plan is booked, refunds are not issued due to your unavailability or vacation or any other personal reasons. However, a delayed start date is possible.
                                            </div>
                                        </div>
                                        <div className='d-flex align-items-start mb-2'>
                                            <i className='lni lni-checkmark mt-1 mx-auto' />
                                            <div className='flex-fill ml-3'>
                                                To get the best results from the nutrition plan, it is highly recommended to incorporate physical activity as an important element. I offer discounts when my clients opt in for both diet and workouts combo packages.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>


                        <Button color='primary' onClick={redirectToPaymentPage} className='mt-4'  >
                            Book Now
                        </Button>
                    </CardBody>
                </Card>
            </Container >
        </React.Fragment>
    );
}